
<style lang="less">
@import "../less/common.less";
.el-select-dropdown {
  z-index: 2007 !important;
}
.exportTip {
  .el-dialog {
    max-width: 420px;
    min-width: 300px;
    .el-dialog__header {
      padding: 10px 20px;
      .el-dialog__title {
        font-size: 14px;
      }
    }
    .el-dialog__body {
      padding: 20px 40px;
      .el-radio {
        margin-right: 20px;
      }
    }
  }
}
#stockDetailID {
  .el-dialog {
    min-width: 1000px;
  }
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__body {
    padding: 12px 30px;
    .productHeader {
      border-bottom: 1px solid #efefef;
      .el-row {
        margin-bottom: 0px;
        .el-col {
          display: flex;
          align-items: center;
          .el-form-item {
            margin-bottom: 10px;
            .el-form-item__label {
              padding: 0 2px 0 0 !important;
            }
            .el-form-item__content {
              .el-date-editor.el-input,
              .el-date-editor.el-input__inner {
                width: 160px;
              }
            }
          }
          .type-flag {
            margin-right: 10px;
            flex: 1;
            text-align: left;
            margin-bottom: 10px !important;
          }
          .export {
            margin-right: 15px;
            margin-bottom: 10px !important;
          }

          .type-show .el-radio {
            margin-right: 15px;
            margin-bottom: 10px !important;
          }
        }
      }
    }
    .showType {
      visibility: hidden;
      height: 0px !important;
      max-height: 0px !important;
      min-height: 0px !important;
      padding: 0px !important;
      margin-bottom: 0px !important;
    }
    .productBodys {
      padding: 6px 10px;
      height: 450px;
      max-height: 450px;
      min-height: 280px;
      .happy-scroll-container {
        width: 98% !important;
        height: 100% !important;
        .el-row {
          margin: 0px !important;
          > .el-col {
            display: flex;
            padding-top: 70px;
            position: relative;
            padding-bottom: 20px;
            border-bottom: 1px solid #efefef;
            text-align: center;
            // > span {
            //   margin: auto;
            // }
            > p {
              position: absolute;
              width: 100%;
              text-align: center;
              top: 10px;
              font-size: 16px;
              font-weight: 600;
            }
            .chart-img-des {
              position: absolute;
              top: 115px;
              width: 70px;
              left: 45px;
              font-size: 14px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .chart-txt {
              > div {
                display: flex;
                align-items: center;
                font-size: 13px;
                margin-bottom: 1px;
              }

              .color-block1 {
                color: #f1bc4c;

                > div {
                  background-color: #f1bc4c;
                  width: 10px;
                  height: 10px;
                  margin-right: 8px;
                }
              }

              .color-block2 {
                color: #4e9bed;

                > div {
                  background-color: #4e9bed;
                  width: 10px;
                  height: 10px;
                  margin-right: 8px;
                }
              }

              > div:nth-child(4) {
                margin-top: 8px;
                margin-bottom: 0px;
              }
            }
          }
        }
        .data-more {
          padding: 4px !important;
          > span {
            margin: auto;
            padding: 40px 0 400px;
          }
        }
        .data-more-up,
        .data-more-down {
          padding: 4px !important;
          > span {
            margin: auto;
            padding: 0px;
            font-size: 12px;
          }
        }
      }
    }
    .productBody {
      padding: 6px 10px;
      height: 80%;
      max-height: 500px;
      min-height: 280px;
      overflow: hidden;
      overflow-y: auto;
      text-align: center;
      > .el-col {
        display: flex;
        padding-top: 70px;
        position: relative;
        padding-bottom: 20px;
        border-bottom: 1px solid #efefef;
        > p {
          position: absolute;
          width: 100%;
          text-align: center;
          top: 10px;
          font-size: 16px;
          font-weight: 600;
        }
        .chart-img-des {
          position: absolute;
          top: 115px;
          width: 70px;
          left: 45px;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .chart-txt {
          > div {
            display: flex;
            align-items: center;
            font-size: 13px;
            margin-bottom: 1px;
          }

          .color-block1 {
            color: #f1bc4c;

            > div {
              background-color: #f1bc4c;
              width: 10px;
              height: 10px;
              margin-right: 8px;
            }
          }

          .color-block2 {
            color: #4e9bed;

            > div {
              background-color: #4e9bed;
              width: 10px;
              height: 10px;
              margin-right: 8px;
            }
          }

          > div:nth-child(4) {
            margin-top: 8px;
            margin-bottom: 0px;
          }
        }
      }
      .el-pagination {
        text-align: right;
        margin-top: 10px;
      }
      .el-pagination.is-background .el-pager li:not(.disabled).active {
        visibility: visible;
        height: auto !important;
      }
      // .data-more {
      //   padding: 4px !important;
      //   > span {
      //     cursor: pointer;
      //     margin: auto;
      //     padding: 0 20px;
      //   }
      //   .el-loading-mask {
      //     .el-loading-spinner {
      //       margin-top: -10px;
      //     }
      //   }
      // }
    }
    .productBody.noData {
      padding: 40px 10px;
    }
    .dialog-footer {
      border-top: 1px solid #efefef;
      padding-top: 16px;
      text-align: center;
    }
  }
}
</style>
<template>
  <el-dialog id="stockDetailID"
             class="stockDetail"
             title="剩余明细详情"
             :visible.sync="stockDetailDialogVisible"
             width="70%"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             append-to-body>
    <div id="stockDetailBody">
      <div class="productHeader">
        <el-form :inline="true"
                 :model="formInline"
                 class="demo-form-inline">
          <el-row>
            <el-col :span="24">
              <el-form-item label="日期：">
                <el-date-picker class="time-option"
                                v-model="formInline.time"
                                align="right"
                                type="date"
                                placeholder="选择日期"
                                :picker-options="pickerOptionsStock"
                                :clearable="false"
                                :editable="false"
                                @change="changeTime"></el-date-picker>
              </el-form-item>
              <el-form-item label="区域：">
                <template v-if="deptAreaList.length">
                  <el-select v-model="formInline.areaId"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             @change="changeArea">
                    <el-option v-for="item in deptAreaList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             @change="changeArea">
                    <el-option v-for="item in deptAreaList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item label="门店：">
                <template v-if="deptList.length">
                  <el-select v-model="formInline.deptId"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             @change="changeDept">
                    <el-option v-for="item in deptList"
                               :key="item.deptId"
                               :label="item.deptName"
                               :value="item.deptId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             @change="changeDept">
                    <el-option v-for="item in deptList"
                               :key="item.deptId"
                               :label="item.deptName"
                               :value="item.deptId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item label="中类：">
                <template v-if="typeList1.length">
                  <el-select v-model="formInline.productTypeId1"
                             collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             @change="changeProductType1">
                    <el-option v-for="item in typeList1"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select collapse-tags
                             filterable
                             multiple
                             placeholder="请选择"
                             @change="changeProductType1">
                    <el-option v-for="item in typeList1"
                               :key="item.productTypeId"
                               :label="item.productTypeName"
                               :value="item.productTypeId"></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item label="小类："
                            v-if="formInline.typeFlag==2">
                <el-select v-model="formInline.productTypeId2"
                           collapse-tags
                           filterable
                           multiple
                           placeholder="请选择"
                           @change="changeProductType2">
                  <el-option v-for="item in typeList2"
                             :key="item.productTypeId"
                             :label="item.productTypeName"
                             :value="item.productTypeId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-radio-group v-model="formInline.typeFlag"
                              @change="changeTypeFlag"
                              size="medium"
                              class="type-flag">
                <el-radio-button :label="0">门店汇总</el-radio-button>
                <el-radio-button :label="1">中类汇总</el-radio-button>
                <el-radio-button :label="2">小类汇总</el-radio-button>
              </el-radio-group>
              <el-button class="export"
                         @click="exportExcel"
                         v-if="formInline.showType==1"
                         size="small">导出</el-button>
              <el-radio-group v-model="formInline.showType"
                              @change="changeShowType"
                              class="type-show">
                <el-radio :label="0">图表展示</el-radio>
                <el-radio :label="1">报表展示</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- &&(formInline.typeFlag!==2||(formInline.typeFlag==2&&formInline.productTypeId2&&formInline.productTypeId2.length>0)) 去除小类是否选择的判断 有些客户没有小类 -->
      <template v-if="formInline.areaId&&formInline.areaId.length>0&&formInline.deptId&&formInline.deptId.length>0&&formInline.productTypeId1&&formInline.productTypeId1.length>0">
        <!-- <el-row id="showIMG"
                class="productBody"
                :class="{ 'showType': formInline.showType==1}"
                :gutter="20">
          <el-col :span="24"
                  class="data-more"
                  v-if="pageIndexImg!=0">
            <span @click="handlePrevImg">点击获取历史数据</span>
          </el-col>
          <el-col :span="6"
                  v-for="(stock,index) in stockDetailListImg"
                  :key="index">
            <p>{{stock.deptName}}</p>
            <div class="chart-img"
                 :id="'myChartStock'+index"
                 :style="{width: '140px', height: '140px'}"></div>
            <p class="chart-img-des"
               :title="stock.productTypeName"
               v-if="formInline.typeFlag!==0">{{stock.productTypeName}}</p>
            <div class="chart-txt">
              <div class="color-block1">
                <div>&nbsp;</div>
                <span>昨日剩货</span>
              </div>
              <div>￥{{stock.lastMoney2}}</div>
              <div>{{stock.lastMoneyPer}}%</div>
              <div class="color-block2">
                <div>&nbsp;</div>
                <span>今日到货</span>
              </div>
              <div>￥{{stock.inMoney2}}</div>
              <div>{{stock.inMoneyPer}}%</div>
            </div>
          </el-col>
          <el-col :span="24"
                  class="data-more"
                  id="more">
            <template v-if="(pageIndexImg+1)*pageSize>=totalCount">
              <span>没有更多数据了！</span>
            </template>
            <template v-else>
              <span @click="handleNextImg">点击加载更多...</span>
            </template>
          </el-col>
        </el-row>color="rgba(79, 192, 141, .7)" -->
        <!-- <div>当前Top: {{pageIndexImg}} {{totalCount}}</div> -->
        <div class="productBodys"
             id="productBodys"
             :class="{ 'showType': formInline.showType==1}">
          <happy-scroll size="6"
                        :scroll-top.sync="scrollTop"
                        @vertical-start="handlePrevImg"
                        @vertical-end="handleNextImg"
                        resize>
            <el-row :gutter="20">
              <el-col :span="24"
                      id="data-more-up"
                      class="data-more-up"
                      v-if="pageIndexImg!=0&&handle=='1'">
                <span @click="handlePrevImg">上滑获取更多数据</span>
              </el-col>
              <el-col :span="6"
                      v-for="(stock,index) in stockDetailListImg"
                      :key="index">
                <p>{{stock.deptName}}</p>
                <div class="chart-img"
                     :id="'myChartStock'+index"
                     :style="{width: '140px', height: '140px'}"></div>
                <p class="chart-img-des"
                   :title="stock.productTypeName"
                   v-if="formInline.typeFlag!==0">{{stock.productTypeName}}</p>
                <div class="chart-txt">
                  <div class="color-block1">
                    <div>&nbsp;</div>
                    <span>昨日剩货</span>
                  </div>
                  <div>￥{{stock.lastMoney2}}</div>
                  <div>{{stock.lastMoneyPer}}%</div>
                  <div class="color-block2">
                    <div>&nbsp;</div>
                    <span>今日到货</span>
                  </div>
                  <div>￥{{stock.inMoney2}}</div>
                  <div>{{stock.inMoneyPer}}%</div>
                </div>
              </el-col>
              <!-- <el-col :span="24"
                      class="data-more"
                      id="more">
                <template v-if="(pageIndexImg+1)*pageSize>=totalCount">
                  <span>没有更多数据了！</span>
                </template>
              </el-col> -->
              <el-col :span="24"
                      class="data-more"
                      id="more"
                      v-if="(pageIndexImg+1)*pageSize>=totalCount">
                <span>没有更多数据了！</span>
              </el-col>
              <el-col :span="24"
                      id="data-more-down"
                      class="data-more-down"
                      v-else>
                <span>下滑取更多数据</span>
              </el-col>
            </el-row>
          </happy-scroll>
        </div>
        <div class="productBody"
             id="productBodys"
             :class="{ 'showType': formInline.showType==0}">
          <template v-if="formInline.typeFlag===0">
            <el-table id="stockDetailData"
                      class="table-common"
                      border
                      :data="stockDetailList"
                      style="width: 100%"
                      height="420"
                      :row-class-name="tableRowClassName"
                      @sort-change="sortChange">
              <el-table-column label-class-name="product-data-index"
                               type="index"
                               label
                               align="center"
                               fixed
                               width="50"></el-table-column>
              <el-table-column prop="deptName"
                               label="门店名称"
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.deptName }}</template>
              </el-table-column>
              <el-table-column prop="lastMoney2"
                               label="昨日剩货"
                               align="right"
                               sortable
                               header-align="right">
                <template slot-scope="scope">{{ scope.row.lastMoney2 }}</template>
              </el-table-column>
              <el-table-column prop="lastMoneyPer"
                               label="昨日剩货百分比"
                               align="right"
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.lastMoneyPer }}%</template>
              </el-table-column>
              <el-table-column prop="inMoney2"
                               label="今日到货"
                               align="right"
                               sortable
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.inMoney2 }}</template>
              </el-table-column>
              <el-table-column prop="inMoneyPer"
                               label="今日到货百分比"
                               align="right"
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.inMoneyPer }}%</template>
              </el-table-column>
              <el-table-column prop="nowLastMoney"
                               label="剩货"
                               align="right"
                               sortable
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.nowLastMoney }}</template>
              </el-table-column>
              <el-table-column prop="deptId"
                               label="操作"
                               align="center"
                               header-align="center">
                <el-button type="text"
                           size="small"
                           slot-scope="scope"
                           @click="showDetail(scope.row.deptId,scope.row.deptName)">详情查看</el-button>
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            <el-table id="stockDetailData"
                      class="table-common"
                      border
                      :data="stockDetailList"
                      style="width: 100%"
                      height="420"
                      :row-class-name="tableRowClassName"
                      @sort-change="sortChange">
              <el-table-column label-class-name="product-data-index"
                               type="index"
                               label
                               align="center"
                               fixed
                               width="50"></el-table-column>
              <el-table-column prop="deptName"
                               label="门店名称"
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.deptName }}</template>
              </el-table-column>
              <el-table-column prop="productTypeName"
                               :label="formInline.typeFlag===1?'中类':'小类'"
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.productTypeName }}</template>
              </el-table-column>
              <el-table-column prop="lastMoney2"
                               label="昨日剩货"
                               align="right"
                               sortable
                               header-align="right">
                <template slot-scope="scope">{{ scope.row.lastMoney2 }}</template>
              </el-table-column>
              <el-table-column prop="lastMoneyPer"
                               label="昨日剩货百分比"
                               align="right"
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.lastMoneyPer }}%</template>
              </el-table-column>
              <el-table-column prop="inMoney2"
                               label="今日到货"
                               align="right"
                               sortable
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.inMoney2 }}</template>
              </el-table-column>
              <el-table-column prop="inMoneyPer"
                               label="今日到货百分比"
                               align="right"
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.inMoneyPer }}%</template>
              </el-table-column>
              <el-table-column prop="nowLastMoney"
                               label="剩货"
                               align="right"
                               sortable
                               header-align="center">
                <template slot-scope="scope">{{ scope.row.nowLastMoney }}</template>
              </el-table-column>
            </el-table>
          </template>

          <el-pagination background
                         @current-change="handleCurrentChange"
                         @prev-click="handlePrev"
                         @next-click="handleNext"
                         :current-page="pageIndex+1"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="totalCount">
          </el-pagination>
        </div>
      </template>
      <template v-else>
        <div class="productBody noData">
          请选择{{formInline.areaId&&formInline.areaId.length>0?formInline.deptId&&formInline.deptId.length>0?formInline.productTypeId1&&formInline.productTypeId1.length>0?formInline.typeFlag==2&&(!formInline.productTypeId2||formInline.productTypeId2.length==0)?'小类':'':'中类':'门店':'区域'}}查询数据！
        </div>
      </template>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="closeStockDetail">关闭</el-button>

      </div>
    </div>
    <!-- 门店明细查询 start -->
    <stockDetailAccount :tHeader="tHeader"
                        :filterVal="filterVal"
                        :time="formInline.time"
                        :deptId="currentDeptId"
                        :deptName="currentDeptName"
                        :stockDADialogVisible="stockDADialogVisible"
                        @close_stockDA="closeStockDA"
                        appendToBody></stockDetailAccount>
    <!-- 门店明细查询 end -->
    <!-- 导出弹框 start -->
    <el-dialog class="exportDialog"
               :visible.sync="centerDialogVisible"
               width="30%"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               append-to-body
               center>
      <el-progress class="exportProgress"
                   :text-inside="false"
                   :show-text="false"
                   :stroke-width="16"
                   :percentage="percentage"></el-progress>
      <p>{{percenttxt}}</p>
    </el-dialog>
    <!-- 导出弹框 end -->
    <el-dialog class="exportTip"
               title="导出范围"
               :visible.sync="exportDialogVisible"
               width="30%"
               append-to-body>
      <el-radio-group v-model="isExportAll">
        <el-radio :label="false">当前页</el-radio>
        <el-radio :label="true">全部</el-radio>
      </el-radio-group>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="exportDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="handleExportData">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import productApi from "@/api/api-product";
import deptApi from "@/api/api-dept";
import stockApi from "@/api/api-stock";
import stockDetailAccount from './stockDetailAccount.vue'
import common from "@/libs/common";
import {
  localToken
} from '@/libs/util';
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";
let loadingStock;
// let loadingMore
export default {
  components: {
    stockDetailAccount
  },
  props: {
    timeValue: {
      type: String,
      default: ''
    },
    stockDetailDialogVisible: {
      type: Boolean,
      default: false
    },
    deptOptions: {
      type: Array,
      default () {
        return []
      }
    },
    deptAreaOptions: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      formInline: {
        time: new Date(),
        areaId: ['all'],
        deptId: ['all'],
        productTypeId1: ['all'],
        productTypeId2: ['all'],
        typeFlag: 0,
        showType: 0
      },
      deptAreaList: [],
      deptList: [],
      typeList1: [],
      typeList2: [],
      stockDetailListOld: [],
      stockDetailList: [],
      stockDetailListImg: [],
      oldDeptArea: ["all"],
      oldDept: ["all"],
      oldProductType1: ["all"],
      oldProductType2: ["all"],
      tableDataStock: [],
      pageIndexImg: 0, // 图表展示页码
      pageIndex: 0, // 报表展示页面
      pageSize: 16,
      totalCount: 0,
      // 时间控件
      pickerOptionsStock: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick (picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick (picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick (picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      // 当前查看当前选中部门信息
      currentDeptId: null,
      currentDeptName: null,
      stockDADialogVisible: false,
      // 导出弹框
      centerDialogVisible: false,
      percentage: 0,
      percenttxt: "导出数据100条,已处理50条,正在导出,请稍等",
      order: "descending",
      prop: "nowLastMoney",
      exportData: [],
      isExportAll: false,
      exportDialogVisible: false,
      tHeader: ['序号', '门店名称', '中类', '昨日剩货', '昨日剩货百分比', '今日到货', '今日到货百分比', '剩货'],
      filterVal: ['index', 'deptName', 'productTypeName', 'lastMoney2', 'lastMoneyPer', 'inMoney2', 'inMoneyPer', 'nowLastMoney'],
      scrollTop: 5,
      handle: '0'
    }
  },

  methods: {
    start (offset) {
      alert('到头部了')
    },
    end (offset) {
      alert('到尾部了')
    },
    //定义导出Excel表格事件
    exportExcel () {
      let that = this;
      if (that.stockDetailListOld.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先查找数据！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      that.exportDialogVisible = true
    },
    handleExportData () {
      let that = this
      let formInline = that.formInline
      let tHeader = []
      let filterVal = []
      if (formInline.typeFlag === 0) {
        tHeader = JSON.parse(JSON.stringify(that.tHeader)).filter((item, index) => index != 2)
        filterVal = JSON.parse(JSON.stringify(that.filterVal)).filter((item, index) => index != 2)
      } else {
        tHeader = JSON.parse(JSON.stringify(that.tHeader)).map((item, index) => {
          if (index == 2) {
            if (formInline.typeFlag === 1) {
              return '中类'
            } else {
              return '小类'
            }
          } else {
            return item
          }
        })
        filterVal = JSON.parse(JSON.stringify(that.filterVal)).map(item => item)
      }
      var dataExport = that.isExportAll ? that.exportData : that.stockDetailList;  //把要导出的数据tableData存到list
      that.centerDialogVisible = true;
      var iSpeed = 1;
      that.percentage = 0;
      that.percenttxt =
        "导出数据" + dataExport.length + "条，已处理0条，正在导出,请稍等";
      var obj = setInterval(function () {
        iSpeed += 6;
        if (iSpeed >= 100) {
          // 设置达到多少进度后停止
          that.percentage = 100;
          that.percenttxt = "导出数据" + dataExport.length + "条，已完成！";
          clearInterval(obj);
          setTimeout(() => {
            that.centerDialogVisible = false;
          }, 200);
        } else {
          that.percentage = iSpeed;
          that.percenttxt =
            "导出数据" +
            dataExport.length +
            "条，已处理" +
            parseInt(dataExport.length * (iSpeed / 100)) +
            "条，正在导出，请稍等";
        }
      }, 12); // 20毫秒后函数执行一次
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/Excel/Export2Excel');//注意这个Export2Excel路径
        // let list = dataExport; // 把要导出的数据tableData存到list
        const data = localToken.formatJson(filterVal, dataExport);
        export_json_to_excel(tHeader, data, "剩余明细详情" + common.getDateDetail());//最后一个是表名字
      })
      that.exportDialogVisible = false
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },
    // 获取部门
    getDept (data) {
      return new Promise((resolve, reject) => {
        deptApi
          .getDept(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getStockDetail (data) {
      return new Promise((resolve, reject) => {
        stockApi
          .getStockDetail(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    closeStockDetail () {
      let that = this
      // loadingStock.close();
      if (loadingStock) {
        that.$nextTick(() => {
          loadingStock.close();
        });
      }
      that.$emit("close_stockDetail", false)
    },
    // 上一页图表
    handlePrevImg () {
      let that = this
      // if (loadingMore) {
      //   that.$nextTick(() => {
      //     loadingMore.close();
      //   });
      // }
      // loadingMore = that.$loading({
      //   lock: true,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255, 255, 255, 0.7)",
      //   target: document.querySelector("#data-more-up")
      // });
      // alert("上")
      // (i == 0 && that.pageIndexImg > 0) || (i > 0 && that.pageIndexImg > -1)
      if (that.pageIndexImg > 0) {
        that.pageIndexImg = that.pageIndexImg - 1
        that.getDate()
        that.scrollTop = 400
        that.handle = '1'
        // loadingMore.close();
      }

    },
    // 下一页图表
    handleNextImg () {
      let that = this
      // if (loadingMore) {
      //   that.$nextTick(() => {
      //     loadingMore.close();
      //   });
      // }
      if ((that.pageIndexImg + 1) * that.pageSize >= that.totalCount) {
        return
      }
      // loadingMore = that.$loading({
      //   lock: true,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255, 255, 255, 0.7)",
      //   target: document.querySelector("#data-more-down")
      // });
      that.pageIndexImg += 1
      that.getDate()
      that.scrollTop = 5
      // loadingMore.close();
    },
    // 当前页改变时触发
    handleCurrentChange (page) {
      let that = this
      that.pageIndex = page - 1
      that.getDate()
    },
    // 上一页按钮改变当前页后触发
    handlePrev (page) {
      let that = this
      that.pageIndex = page - 1
      that.getDate()
    },
    // 下一页按钮改变当前页后触发
    handleNext (page) {
      let that = this
      that.pageIndex = page - 1
      that.getDate()
    },
    // 排序
    sortChange (opt) {
      // alert(JSON.stringify(opt))
      this.order = opt.order
      this.prop = opt.prop
      this.getDate()
    },
    getDate () {
      let that = this
      let data = JSON.parse(JSON.stringify(that.stockDetailListOld))
      // 数组排序
      if (that.order && that.prop) {
        data.sort(localToken.compare(that.prop))
        if (that.order !== 'ascending') {
          data.reverse()
        }
      }
      that.exportData = data.map((item, index) => {
        item["index"] = index + 1
        return item
      })
      let showType = that.formInline.showType // 0图标 1报表
      let pageIndex = 0
      let pageSize = that.pageSize
      if (showType == 0) {
        pageIndex = that.pageIndexImg
        let i = 0
        that.stockDetailListImg = data.filter((item, index) => {
          if (index >= pageIndex * pageSize - 4 && index < (pageIndex + 1) * pageSize) {
            i++
            item["index"] = i
            return item
          }
        })
        setTimeout(() => {
          that.drawLineStock()
          // if (loadingMore) { loadingMore.close(); }
        }, 200);
      } else {
        pageIndex = that.pageIndex
        let i = 0
        that.stockDetailList = data.filter((item, index) => {
          if (index >= pageIndex * pageSize && index < (pageIndex + 1) * pageSize) {
            i++
            item["index"] = i
            return item
          }
        })
      }
    },
    // 切换展示方式
    changeShowType () {
      this.getDate()
    },
    // 绘制图表
    drawLineStock () {
      let that = this;
      let data = that.stockDetailListImg
      data.map((item, index) => {
        // 基于准备好的dom，初始化echarts实例
        let myChart = that.$echarts.init(document.getElementById("myChartStock" + index));
        // 绘制图表
        myChart.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          color: ["#f1bc4c", "#4c9aef"],
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["45%", "80%"],
              center: ["50%", "50%"],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: "center"
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(255, 255, 255, 0.2)",
                  textColor: "#000"
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [
                { value: item.lastMoney2, name: "昨日剩货" },
                {
                  value: item.inMoney2,
                  name: "今日到货"
                }
              ]
            },
            // 边框的设置
            {
              radius: ["70%", "80%"],
              center: ["50%", "50%"],
              type: "pie",
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              animation: false,
              tooltip: {
                show: false
              },
              itemStyle: {
                normal: {
                  color: "rgba(250,250,250,0.2)"
                }
              },
              data: [
                {
                  value: 1
                }
              ]
            }
          ]
        });
      })

    },
    // 切换汇总方式
    changeTypeFlag () {
      this.getStock()
    },
    // 切换时间 重新请求数据
    changeTime () {
      this.getStock()
    },
    // 切换区域，根据区域获取门店 重新请求数据
    changeArea (val) {
      let that = this
      const allValues = [];
      for (const item of that.deptAreaList) {
        allValues.push(item.id);
      }
      const oldVal =
        that.oldDeptArea.length === 1 ? that.oldDeptArea[0] : [];
      if (val.includes("all")) that.$set(that.formInline, 'areaId', allValues)
      if (oldVal.includes("all") && !val.includes("all"))
        that.$set(that.formInline, 'areaId', [])
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.$set(that.formInline, 'areaId', val)
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        console.log(11);
        if (val.length === allValues.length - 1)
          that.$set(that.formInline, 'areaId', ["all"].concat(val))
      }
      that.oldDeptArea[0] = that.formInline.areaId;

      if (that.formInline.areaId.length == 0) {
        that.$set(that.formInline, 'deptId', [])
        that.$set(that.formInline, 'productTypeId1', [])
        that.$set(that.formInline, 'productTypeId2', [])
        that.deptList = []
        that.typeList2 = []
        that.oldDept = []
        that.oldProductType1 = []
        that.oldProductType2 = []
      } else {
        let data = { AreaId: that.formInline.areaId[0] === 'all' ? [] : that.formInline.areaId }
        that.getDept(data).then(
          res => {
            let deptList = [{ deptId: "all", deptName: "全选" }].concat(res)
            let deptId = []
            that.deptList = deptList.map(item => {
              deptId.push(item.deptId)
              return item
            })
            that.$set(that.formInline, 'deptId', deptId)
            that.oldDept = ['all']
          },
          err => {
            console.log(err)
          }
        )
      }
      that.getStock()
    },
    // 切换门店 重新请求数据
    changeDept (val) {
      let that = this
      const allValues = [];
      for (const item of that.deptList) {
        allValues.push(item.deptId);
      }
      const oldVal =
        that.oldDept.length === 1 ? that.oldDept[0] : [];
      if (val.includes("all")) that.$set(that.formInline, 'deptId', allValues)
      if (oldVal.includes("all") && !val.includes("all"))
        that.$set(that.formInline, 'deptId', [])
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.$set(that.formInline, 'deptId', val)
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.$set(that.formInline, 'deptId', ["all"].concat(val))
      }
      that.oldDept[0] = that.formInline.deptId;
      if (that.formInline.deptId.length == 0) {
        that.$set(that.formInline, 'productTypeId1', [])
        that.$set(that.formInline, 'productTypeId2', [])
        that.typeList2 = []
        that.oldProductType1 = []
        that.oldProductType2 = []
      }
      that.getStock()
    },
    // 切换中类 重新请求数据
    changeProductType1 (val) {
      let that = this
      const allValues = [];
      for (const item of that.typeList1) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        that.oldProductType1.length === 1 ? that.oldProductType1[0] : [];
      if (val.includes("all")) that.$set(that.formInline, 'productTypeId1', allValues)
      if (oldVal.includes("all") && !val.includes("all"))
        that.$set(that.formInline, 'productTypeId1', [])
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.$set(that.formInline, 'productTypeId1', val)
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.$set(that.formInline, 'productTypeId1', ["all"].concat(val))
      }
      that.oldProductType1[0] = that.formInline.productTypeId1;
      if (that.formInline.productTypeId1.length == 0) {
        that.$set(that.formInline, 'productTypeId2', [])
        that.typeList2 = []
        that.oldProductType2 = []
        that.getStock()
      } else {
        let data = { TypeFlag: 0 }
        if (that.formInline.productTypeId1[0] !== 'all') { data["typeId"] = that.formInline.productTypeId1 }
        that.getProductTypeListByFLag(data).then(
          res => {
            let typeList2 = [{ productTypeId: "all", productTypeName: "全选" }].concat(res)
            let productTypeId2 = []
            that.typeList2 = typeList2.map(item => {
              productTypeId2.push(item.productTypeId)
              return item
            })
            that.$set(that.formInline, 'productTypeId2', productTypeId2)
            that.oldProductType2 = ['all']
            that.getStock()
          },
          err => {
            console.log(err)
          }
        )
      }

    },
    // 切换小类 重新请求数据
    changeProductType2 (val) {
      let that = this
      const allValues = [];
      for (const item of that.typeList2) {
        allValues.push(item.productTypeId);
      }
      const oldVal =
        that.oldProductType2.length === 1 ? that.oldProductType2[0] : [];
      if (val.includes("all")) that.$set(that.formInline, 'productTypeId2', allValues)
      if (oldVal.includes("all") && !val.includes("all"))
        that.$set(that.formInline, 'productTypeId2', [])
      if (oldVal.includes("all") && val.includes("all")) {
        const index = val.indexOf("all");
        val.splice(index, 1); // 排除全选选项
        that.$set(that.formInline, 'productTypeId2', val)
      }
      if (!oldVal.includes("all") && !val.includes("all")) {
        if (val.length === allValues.length - 1)
          that.$set(that.formInline, 'productTypeId2', ["all"].concat(val))
      }
      that.oldProductType2[0] = that.formInline.productTypeId2;
      that.getStock()
    },

    // 根据中类小类获取商品分类列表
    // TypeFlag 0小类 1中类
    // TypeId 中类id,查询中类下小类列表(可不传)
    getProductTypeListByFLag (data) {
      return new Promise((resolve, reject) => {
        productApi
          .getProductTypeListByFLag(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getStock () {
      let that = this
      // if (loadingStock) {
      //   that.$nextTick(() => {
      //     loadingStock.close();
      //   });
      // }
      loadingStock = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector("#productBody")
      });
      // 初始化页码
      that.pageIndex = 0
      that.pageIndexImg = -1
      that.totalCount = 0
      let formInline = that.formInline
      let data = {
        "searchDate": formInline.time,
        "areaId": formInline.areaId[0] === 'all' ? [] : formInline.areaId,
        "deptId": formInline.deptId[0] === 'all' ? [] : formInline.deptId,
      }
      if (formInline.typeFlag === 0) {
        // 门店汇总
        data["typeFlag"] = null
        data["productTypeId"] = formInline.productTypeId1[0] === 'all' ? [] : formInline.productTypeId1
      } else if (formInline.typeFlag === 2) {
        //按门店、小类汇总
        data["typeFlag"] = 0
        data["productTypeId"] = formInline.productTypeId2.filter(item => item != 'all') // formInline.productTypeId2[0] === 'all' ? [] : formInline.productTypeId2
      } else {
        // 中类汇总
        data["typeFlag"] = 1
        data["productTypeId"] = formInline.productTypeId1[0] === 'all' ? [] : formInline.productTypeId1
      }
      that.getStockDetail(data).then(res => {
        that.stockDetailListOld = res.map((item, index) => {
          item["index"] = index + 1
          item["inMoney2"] = Math.round(item.inMoney * 100) / 100; // 今日到货
          item["lastMoney2"] = Math.round(item.lastMoney * 100) / 100; // 昨日剩货
          item["totalMoney2"] =
            Math.round((item.inMoney + item.lastMoney) * 100) / 100; // 今日总货量
          item["inMoneyPer"] =
            Math.round(
              (item["totalMoney2"] ? (item["inMoney2"] / item["totalMoney2"]) * 100 : 100) *
              100
            ) / 100; // 今日到货占比
          item["lastMoneyPer"] = Math.round((100 - item.inMoneyPer) * 100) / 100; // 昨日剩货占比
          item["nowLastMoney"] =
            Math.round((item.inMoney + item.lastMoney - item.outMoney) * 100) /
            100; // 剩货
          item["nowLastMoneyPer"] =
            Math.round(
              (item["totalMoney2"]
                ? (item["nowLastMoney"] / item["totalMoney2"]) * 100
                : 100) * 100
            ) / 100; // 剩货占比
          return item
        })
        that.totalCount = that.stockDetailListOld.length
        that.getDate()
        loadingStock.close();
      }, err => {
        loadingStock.close();
        console.log(err)
      })
    },
    showDetail (id, name) {
      this.currentDeptId = id
      this.currentDeptName = name
      this.stockDADialogVisible = true
    },
    closeStockDA () {
      this.currentDeptId = null
      this.currentDeptName = null
      this.stockDADialogVisible = false
    },
    init () {
      let that = this
      // TypeFlag 0小类 1中类
      // TypeId 中类id,查询中类下小类列表(可不传)
      Promise.all([that.getProductTypeListByFLag({ TypeFlag: 1 }), that.getProductTypeListByFLag({ TypeFlag: 0 }), that.getDept({ AreaId: [] })])
        .then(
          res => {
            let typeList1 = [{ productTypeId: "all", productTypeName: "全选" }].concat(res[0])
            let typeList2 = [{ productTypeId: "all", productTypeName: "全选" }].concat(res[1])
            let deptList = [{ deptId: "all", deptName: "全选" }].concat(res[2])
            let deptAreaList = [{ id: "all", name: "全选" }].concat(that.deptAreaOptions)
            let productTypeId1 = []
            let productTypeId2 = []
            let deptId = []
            let areaId = []
            that.typeList1 = typeList1.map(item => {
              productTypeId1.push(item.productTypeId)
              return item
            })
            that.typeList2 = typeList2.map(item => {
              productTypeId2.push(item.productTypeId)
              return item
            })
            that.deptList = deptList.map(item => {
              deptId.push(item.deptId)
              return item
            })
            that.deptAreaList = deptAreaList.map(item => {
              areaId.push(item.id)
              return item
            })
            that.order = "descending"
            that.prop = "nowLastMoney"
            that.$set(that.formInline, 'time', that.timeValue)
            that.$set(that.formInline, 'areaId', areaId)
            that.$set(that.formInline, 'deptId', deptId)
            that.$set(that.formInline, 'productTypeId1', productTypeId1)
            that.$set(that.formInline, 'productTypeId2', productTypeId2)
            that.$set(that.formInline, 'typeFlag', 0)
            that.$set(that.formInline, 'showType', 0)
            that.getStock()
          },
          err => {
            console.log(err)
          }
        )
        .catch(err => {
          console.log(err)
        });
    }
  },
  mounted () {
  },
  watch: {
    // 路由变化
    stockDetailDialogVisible (val) {
      if (val) {
        this.pageIndexImg = -1 // 图表展示页码
        this.pageIndex = 0 // 报表展示页面
        this.pageSize = 16
        this.totalCount = 0
        this.init()
      } else {
        if (loadingStock) {
          this.$nextTick(() => {
            loadingStock.close();
          });
        }
        // if (loadingMore) {
        //   this.$nextTick(() => {
        //     loadingMore.close();
        //   });
        // }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/main/stockDetail.vue